<template>
    <div class="full-container">
        <h2>
            <template v-if="searchMode">
                {{translate('offer_search')}}
            </template>
            <template v-else>
                {{translate('choose_offer')}}
            </template>
        </h2>
        <div class="filter-container filter">
            <div :class="['container', 'active']">
                <span class="icon-loop"/>
                <input type="text" :placeholder="translate('filter_loaded_offer_list')" @input="filter($event.target.value)"/>
            </div>
        </div>

        <div class="display-offers-container">
            <div class="fans-offer-container">
                <div class="table-row no-hover">
                    <div class="table-header" :class="(column.style)?column.style:[]" v-for="column in columns">
                        <div :class="{'sortable':column.sortable}" @click="sortColumn(column.title)">
                            <span v-if="column.translatable===false">{{column.name}}</span>
                            <span v-else>{{translate(column.title)}}</span>
                            <span v-if="column.sortable" class="sort-order"
                                  :class="{'active' : sorting[column.title]?sorting[column.title].current:false}">
                                        {{(sorting[column.title])?(sorting[column.title].order)?'ASC':'DESC':''}}
                                    </span>
                        </div>
                    </div>
                </div>
                <div class="table-row" v-for="elem in getAllOffers" @click="loadOffer(elem.id)">
                    <div class="table-content width-col-150">
                        <div class="full-height">{{elem.commission}}</div>
                    </div>
                    <div class="table-content">
                        <div class="full-height">{{elem.fan_type_number}}</div>
                    </div>
                    <div class="table-content">
                        <div>{{elem.id_offer_received}}
                            <div @click="copyStringToClipboard(elem.id_offer_received, $event)"
                                 class="back-btn small-btn">
                                <span>{{translate('copy')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="table-content width-col-150">
                        <div class="full-height">{{elem.version}}</div>
                    </div>
                    <div class="table-content width-col-150">
                        <div class="full-height">{{translate(getOfferStatus(elem))}}</div>
                    </div>
                    <div class="table-content">
                        <div class="full-height">{{elem.project_number}}</div>
                    </div>
                    <div class="table-content">
                        <div class="full-height">{{elem.engine_power}}</div>
                    </div>
                    <div class="table-content">
                        <div>{{elem.id_offer_temp}}
                            <div @click="copyStringToClipboard(elem.id_offer_temp, $event)" class="back-btn small-btn">
                                <span>{{translate('copy')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="table-content width-col-190">
                        <div class="full-height">{{(elem.is_sent == 1)?translate('yes'):translate('no')}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="navi-btns">
            <div @click="$router.go(-1)" class="back-btn"><span>{{translate("back_btn")}}</span></div>
        </div>
    </div>
</template>

<script>
    import {Calculator} from './../calculator.js';
    import debounce from 'lodash.debounce';

    export default {
        name: "DisplayOffers",
        data() {
            return {
                offers: [],
                offersConst: [],
                searchMode: false,
                phrase: '',
                sorting: {},
                lastSortedColumnCode: '',
                columns: [
                    {
                        title: 'commission',
                        sortable: true,
                        style: [
                            'width-col-150'
                        ]
                    },
                    {
                        title: 'fan_type_number',
                        sortable: true
                    },
                    {
                        title: 'id_offer_received',
                        name: 'ID OS',
                        translatable: false,
                        sortable: true
                    },
                    {
                        title: 'version',
                        name: 'offer_version',
                        style: [
                            'width-col-150'
                        ],
                        sortable: true
                    },
                    {
                        title: 'status',
                        name: 'Status',
                        translatable: false,
                        style: [
                            'width-col-150'
                        ]
                    },
                    {
                        title: 'project_number',
                        sortable: true
                    },
                    {
                        title: 'rated_power',
                        sortable: true
                    },
                    {
                        title: 'id_offer_temp',
                        name: 'ID OL',
                        translatable: false,
                        sortable: true
                    },
                    {
                        title: 'received_onto_server',
                        style: [
                            'width-col-190'
                        ],
                        sortable: true
                    }
                ]
            }
        },

        created() {
            this.$store.watch(
                (state) => state.offerSearchQuery,
                (value, oldValue) => {
                    this.loadOffers();
                });
        },

        methods: {

            sortColumn(name) {
                if (this.lastSortedColumnCode === name) {
                    this.sorting[name].order = !this.sorting[name].order;
                }

                this.offers.sort((a, b) => {
                    if (this.sorting[name].order) {
                        return a[name] > b[name] ? 1 : -1;
                    } else {
                        return b[name] > a[name] ? 1 : -1;
                    }
                })

                this.lastSortedColumnCode = name;

                for (let field in this.sorting) {
                    if (this.sorting.hasOwnProperty(field)) {
                        this.sorting[field].current = false;
                    }
                }
                this.sorting[name].current = true;
            },

            filter: debounce(function(filter) {
                if (filter === '') {
                    this.offers = this.offersConst;
                    return;
                }

                filter = filter.toLowerCase();

                this.offers = this.offersConst.filter(x =>
                    x.id_offer_received.toLowerCase().includes(filter)
                    || x.fan_type_number.toLowerCase().includes(filter)
                    || x.commission.toLowerCase().includes(filter)
                    || x.id_offer_temp.toLowerCase().includes(filter)
                    || x.project_number.toLowerCase().includes(filter)
                    || x.engine_power.toLowerCase().includes(filter.replace(',','.'))
                )
            }, 500),

            loadDefaultSorting() {
                this.columns.forEach((el) => {
                    if (el.sortable) {
                        this.sorting[el.title] = {
                            order: true,
                            current: false
                        }
                    }
                });
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },

            copyStringToClipboard(str, event) {
                event.preventDefault();
                event.stopPropagation();
                var el = document.createElement('textarea');
                el.value = str;
                el.setAttribute('readonly', '');
                el.style = {position: 'absolute', left: '-9999px'};
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
            },

            parseGetParameter(name) {
                name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
                var results = regex.exec(location.search);
                return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
            },

            getOfferStatus(offer) {
                if (offer.is_cancelled == 1) {
                    return 'offer_cancelled';
                }
                if (offer.is_approved == 1) {
                    return 'offer_approved';
                }
                return 'offer_awaiting';
            },

            loadOffers() {
                let searchParam = this.parseGetParameter('search');
                if (searchParam !== '') {
                    let form = new FormData();
                    form.append('id', searchParam);
                    this.$apiController.getOfferOfServerId(form)
                        .then((res) => {
                            if (res.status === 'success') {
                                if (res.data.length > 0) {
                                    this.offers = res.data;
                                    this.offersConst = JSON.parse(JSON.stringify(this.offers));
                                } else {
                                    this.$notifications.add(this.$notifications.TYPES.WARNING, this.translate('no_offer'), this.translate('no_offer_id_was_found'));
                                }
                            } else {

                            }
                        });
                    this.offers = this.$store.state.offerSearchResults;
                    this.searchMode = true;
                } else {
                    this.$apiController.getOffersOfUser()
                        .then((res) => {
                            if (res.status === 'success') {
                                this.offers = res.data;
                                this.offersConst = JSON.parse(JSON.stringify(this.offers));
                            }
                        });
                    this.searchMode = false;
                }
            },

            loadOffer(id) {
                if (!isNaN(id)) {
                    let form = new FormData();
                    form.append('id', id);
                    this.$apiController.getOfferOfId(form)
                        .then((res) => {
                            if (res.status === 'success') {
                                if(res.data === null) {
                                    this.$notifications.add(this.$notifications.TYPES.WARNING, this.translate('insufficient_privileges'), this.translate('no_access_to_this_offer'));
                                    return;
                                }

                                this.$store.commit('resetOfferState');
                                Calculator.popFansTable(this.$store);
                                this.$store.state.productCard.custom = res.data.offer_data;
                                let lastPathParameters = res.data.offer_data.last_path_parameters;
                                let activeFan = res.data.offer_data.active_fan;
                                this.$store.state.activeFun = res.data.offer_data.active_fan;
                                this.$store.state.productCard.custom.version = res.data.version;
                                this.$store.state.lastPathParameters = {
                                    selectedFirstStepElement: lastPathParameters.selectedFirstStepElement.id,
                                    selectedSecondStepElement: lastPathParameters.selectedSecondStepElement.id,
                                    selectedThirdStepElement: lastPathParameters.selectedThirdStepElement.id
                                };

                                if(res.data.offer_data.hasOwnProperty("discount")){
                                  this.$store.state.discount.offerDiscountGivenByTheAdministrator = res.data.offer_data.discount.offerDiscountGivenByTheAdministrator;
                                }else{
                                  this.$store.state.discount.offerDiscountGivenByTheAdministrator = 0;
                                }

                                if(res.data.offer_data.hasOwnProperty("params_table")) {
                                    this.$store.state.fansTableData.params_table_loaded = res.data.offer_data.params_table;
                                }

                                this.$store.state.selectedFirstStepElement = lastPathParameters.selectedFirstStepElement;
                                this.$store.commit('loadSecondStepData');
                                this.$store.state.selectedSecondStepElement = lastPathParameters.selectedSecondStepElement;
                                this.$store.commit('loadThirdStepData');
                                this.$store.state.selectedThirdStepElement = lastPathParameters.selectedThirdStepElement;
                                this.$store.commit('changeActiveConfigurationStep', {step: 4});
                                this.$store.state.productCard.custom.id_offer_received = res.data.id_offer_received;
                                this.$store.state.productCard.loaded = true;
                                this.$store.state.productCard.custom.id_offer_db = res.data.id;
                                activeFan['imgSrc'] = activeFan.src;
                                this.$notifications.add(this.$notifications.TYPES.NOTIFICATION, this.translate('notification_success'), this.translate('offer_load_success'));
                                Calculator.addFanToResultTable(activeFan, this.$store);

                                let fourthStepParameters = res.data.offer_data.fourth_step_parameters_selected;

                                this.$apiController.getFansOfPath(this.$store.state.selectedFirstStepElement.id, this.$store.state.selectedSecondStepElement.id).then(
                                    function (response) {
                                        this.$store.state.fansOfPath = this.$apiController.manageReturnedData(response, []);
                                        if (this.$store.state.fansTableData.fans_table.length > 0) {
                                            this.$store.commit({
                                                type: 'selectFanRowAsActiveInFansTable',
                                                fan_id: 0,
                                            });
                                            this.$store.commit({
                                                type: 'manageSelectedFan',
                                            });
                                        }
                                    }.bind(this));
                                this.$store.state.selectedWorkPoint = res.data.offer_data.selected_work_point;
                                this.$store.state.productCard.savedWorkPoint = res.data.offer_data.graphs_summary;
                                if (res.data.is_approved == 1) {
                                    this.$store.state.productCard.custom.is_approved = true;
                                } else {
                                    this.$store.state.productCard.custom.is_approved = false;
                                }

                                if (res.data.is_cancelled == 1) {
                                    this.$store.state.productCard.custom.is_cancelled = true;
                                } else {
                                    this.$store.state.productCard.custom.is_cancelled = false;
                                }

                                window._this = this.$store;
                                for (let paramName in fourthStepParameters) {
                                    if (this.$store.state.fourthStepParameters.hasOwnProperty(paramName)) {

                                        if (fourthStepParameters[paramName].hasOwnProperty('value')) {
                                            this.$store.state.fourthStepParameters[paramName].value = fourthStepParameters[paramName].value;
                                        }

                                        if (fourthStepParameters[paramName].hasOwnProperty('options')) {
                                            if (fourthStepParameters[paramName].options.hasOwnProperty(0)) {
                                                for (let paramOption in fourthStepParameters[paramName].options) {
                                                    if (fourthStepParameters[paramName].options[paramOption]['type'] === 'radio') {
                                                        this.$store.state.fourthStepParameters[paramName].options[paramOption] = fourthStepParameters[paramName].options[paramOption];
                                                    }

                                                    if (fourthStepParameters[paramName].options[paramOption]['type'] === 'select') {
                                                        for (let optionElement in fourthStepParameters[paramName].options[paramOption]['elements']) {
                                                            if (fourthStepParameters[paramName].options[paramOption]['elements'].hasOwnProperty(optionElement) &&
                                                                !this.$store.state.fourthStepParameters[paramName].options[paramOption].hasOwnProperty('unitType')) {
                                                                this.$store.state.fourthStepParameters[paramName].options[paramOption]['elements'][optionElement].active = fourthStepParameters[paramName].options[paramOption]['elements'][optionElement].active;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                
                                this.$store.state.fourthStepParametersSelected = this.$store.state.fourthStepParameters;
                                // NVS-125
                                if(res.data.offer_data.hasOwnProperty("parts_of_the_graph")) {
                                    this.$store.state.partsOfTheGraph = res.data.offer_data.parts_of_the_graph;
                                } else this.manageSelectedPartsOfGraphs();
                                this.$router.push('/');
                            }
                        })
                } else {
                    this.$notifications.add(this.$notifications.TYPES.ERROR, this.translate('offer_error'), this.translate('offer_format_not_valid'));
                }
            },

            manageSelectedPartsOfGraphs() {
                let pressureType = this.$fanObjParamsManager.getPressureType(this.$store);
                pressureType = pressureType.charAt(0).toUpperCase() + pressureType.slice(1);

                for (let axis in this.$store.state.partsOfTheGraph.mainAxisParams) {
                    if (axis == "pressure") {
                        this.$store.state.partsOfTheGraph.mainAxisParams[axis].active = true;
                    }

                    for (let specificParts in this.$store.state.partsOfTheGraph.mainAxisParams[axis].specificParts) {
                        if (specificParts == pressureType + "Pressure" || specificParts == "DynamicPressure" ||
                            (specificParts == "PowerOnShaftWithMaterial" && this.$store.state.fourthStepParametersSelected.material_amount.value > 0) ||
                            (specificParts == "PowerOnShaft" && this.$store.state.fourthStepParametersSelected.material_amount.value == 0)) {
                            this.$store.state.partsOfTheGraph.mainAxisParams[axis].specificParts[specificParts].active = true;
                        } else {
                            this.$store.state.partsOfTheGraph.mainAxisParams[axis].specificParts[specificParts].active = false;
                        }
                    }
                }

                this.$store.commit({
                    type: 'clearMainAxisParams'
                });

                this.$store.commit({
                    type: 'selectMainAxisParam',
                    param_id: 'pressure'
                });

                this.$store.state.partsOfTheGraphChanged++;
            },
        },

        computed: {
            getAllOffers() {
                return this.offers;
            },
        },

        mounted() {
            this.$forceUpdate();
            this.loadOffers();
            this.loadDefaultSorting();
        },

        destroyed() {
            this.$store.state.offerSearchResults = [];
            this.$store.state.offerSearchQuery = '';
        }
    }
</script>

<style scoped>
</style>